export const authorBio = {
  heading: 'Jane Corry',
  text: [
    'Jane Corry is a writer and journalist who has spent time working as the writer in residence of a high security prison for men - an experience that helped inspire her Sunday Times bestsellers.',
    'Jane runs regular writing workshops and speaks at literary festivals all over the world. Many of her ideas strike during morning dog-jogs along the beach followed by a dip in the sea.',
  ],
  cta: {
    label: 'Find out more about Jane',
    to: '/aboutme',
  },
  newsletter: {
    buttonLabel: 'Sign up to my newsletter',
    to: '/newsletter',
    afterText: 'and I will send you a free short story.',
  },
  image: {
    key: 'janetsirs', 
    alt: 'Jane Corry Profile holding her newest Book',
  },
};
